var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "nav-list overflow-auto",
      class:
        (_vm.collapse ? "show" : "") + " " + (_vm.maxPage ? "icon-show" : ""),
      staticStyle: { display: "block" },
    },
    _vm._l(
      _vm.permissions.filter(function (e) {
        return e.view == true
      }),
      function (item, key) {
        return _c(
          "div",
          { key: key },
          [
            item.route
              ? _c(
                  "router-link",
                  {
                    staticClass: "gv-link",
                    attrs: { to: { name: item.route } },
                  },
                  [
                    _c("i", { class: item.icon }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                  ]
                )
              : item.items.length == 0 && !item.route
              ? _c("span", { staticClass: "gv-link" }, [
                  _c("i", { class: item.icon }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.name))]),
                ])
              : _c(
                  "a",
                  {
                    staticClass: "gv-link",
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#collapse_" + item.id,
                    },
                  },
                  [
                    _c("div", { staticClass: "down" }, [
                      _c("i", {
                        class:
                          "bi bi-" +
                          (item.items.findIndex(function (e) {
                            return _vm.$route.name == e.route
                          }) != -1
                            ? "caret-up"
                            : "caret-down"),
                      }),
                    ]),
                    _vm._v(" "),
                    _c("i", { class: item.icon }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                  ]
                ),
            _vm._v(" "),
            item.items.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "collapse",
                    class:
                      item.items.findIndex(function (e) {
                        return _vm.$route.name == e.route
                      }) != -1
                        ? "show"
                        : "",
                    attrs: { id: "collapse_" + item.id },
                  },
                  _vm._l(
                    item.items.filter(function (e) {
                      return e.view == true
                    }),
                    function (value, index) {
                      return _c(
                        "router-link",
                        {
                          key: index,
                          staticClass: "gv-link pl-3",
                          class:
                            "" +
                            (_vm.$route.name == value.route ? "active" : ""),
                          attrs: { to: { name: value.route } },
                        },
                        [
                          _c("i", { class: value.icon }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(value.name))]),
                        ]
                      )
                    }
                  ),
                  1
                )
              : _vm._e(),
          ],
          1
        )
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }